import { defineQuartzConfig } from 'quartz-core/config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'app',
  historyBasename: '/product-updates/:portalId',
  htmlTitle: 'Product Updates',
  htmlTitleLangKey: 'app.htmlTitle',
  copilotLayoutType: 'panel-with-scroll'
});